import { render, staticRenderFns } from "./ProcessCertificate.vue?vue&type=template&id=d2519f90&scoped=true"
import script from "./ProcessCertificate.vue?vue&type=script&lang=js"
export * from "./ProcessCertificate.vue?vue&type=script&lang=js"
import style0 from "./ProcessCertificate.vue?vue&type=style&index=0&id=d2519f90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2519f90",
  null
  
)

export default component.exports